import styled from 'styled-components';
import { Col as ColAntd, Row as RowAntd, Button as ButtonAntd, Image} from 'antd';


export const Button = styled(ButtonAntd)`
    left: 0;
    display: flex;

    &:hover {
        color: #F9BE84;
        border-color: #F9BE84;
    }
`

export const Col = styled(ColAntd)`
   
`

export const Img = styled(Image)`
    @media screen and (max-width: 1500px) {
        
    }

    @media screen and (max-width: 768px) {
        
    }
`

export const Row = styled(RowAntd)`

}
`

export const DivTextSlider = styled.div`
    position: absolute;
    bottom: 35px;
    left: 30px;
`
export const H2TextSlider = styled.h2`
    color: #fff;
    font-size: 50px;

    @media screen and (max-width: 1500px) {
        font-size: 30px;
    }
  
    @media screen and (max-width: 768px) {
        font-size: 21px;
    }
`